import { Component, Input, OnInit } from '@angular/core';
import { GfTitleService } from '../../../services/core.title.service';
import * as _ from 'lodash';
import { UserRest } from '../../../services/core.user.rest.service';
import { UserService } from '../../../services/core.user.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { SettingService } from '../../../services/core.setting.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'user-home-view',
  template: require('./user.home.component.html')
})
export class UserHomeViewComponent implements OnInit {
  @Input() user: any;

  displayAudit = false;
  hidePaging = true;
  projectFilter: string;
  sameUser: boolean;
  activity: any[];
  projects: any[];
  queue: any[];
  activityPage = 1;
  activityPageSize = 10;
  hasNextPage = false;

  constructor(
    private stateService: StateService,
    private userRest: UserRest,
    private titleService: GfTitleService,
    private userService: UserService,
    private translateService: GfTranslateService,
    private settingService: SettingService
  ) {}

  ngOnInit(): void {
    this.projectFilter = this.translateService.translate('Top Projects');
    const unixName = _.get(this.stateService.params, 'unixName', '');
    this.titleService.setTitle(this.userService.fullName(this.user));
    this.sameUser = unixName === this.userService.session.getUnixName();
    this.activity = _.get(this.user, 'rel.activitylog', []);
    this.projects = _.get(this.user, 'rel.projects', []);
    this.queue = _.get(this.user, 'rel.queue', []);
    this.settingService.fetch('user', this.user.id, 'project-view', 'top')
      .then((ret: any) => {
        if (ret.settingValue === 'all') {
          this.setProjectFilter('All Projects', false);
        } else {
          this.setProjectFilter('Top Projects', false);
        }
      });
  }

  setProjectFilter(value: string, persistSelection?: boolean): void {
    this.projectFilter = value;
    if (persistSelection === undefined) {
      persistSelection = true;
    }

    let sortField = '';
    let sortDir = '';
    let pageSize = 5;

    if (this.projectFilter === 'All Projects') {
      if (persistSelection) {
        this.setDefaultProjectView('all');
      }
      sortField = 'projectName';
      sortDir = 'asc';
      pageSize = 40;
    } else {
      if (persistSelection) {
        this.setDefaultProjectView('top');
      }
      sortField = 'activity';
      sortDir = 'desc';
      pageSize = 5;
    }

    this.projects = null;
    const unixName = _.get(this.stateService.params, 'unixName', '');
    this.userRest.getProjects(unixName, {
      sort_field: sortField,
      sort_dir: sortDir,
      page_size: pageSize
    }).then((resource: any) => {
      this.projects = resource.items;
    });
  }

  getActivityLog(): void {
    const unixName = _.get(this.stateService.params, 'unixName', '');
    let params = { max: this.activityPageSize, page_num: this.activityPage, startDate: '1970', endDate: 'now' };
    this.userRest.getUserActivity(unixName, params).then((resource: any) => {
      this.activity = resource.items;
      this.hasNextPage = resource.items.length === this.activityPageSize;
    });
  }

  setDefaultProjectView(defaultProjectView: string): void {
    this.settingService.post({
      settingName: 'project-view',
      section: 'user',
      refId: this.user.id,
      settingValue: defaultProjectView
    });
  }

  public changePage(params: any): void {
    this.activityPage = params.pageNum;
    this.activityPageSize = params.pageSize;
    this.getActivityLog();
  }
}
